import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { Link, useNavigate } from "react-router-dom";

import UserSidebar from "../components/user/UserSidebar";
import UserHeader from "../components/user/UserHeader";

import "./UserDashboard.css";



function UserDashboard() {

  const navigate = useNavigate();

  const [name, setName] = useState("Student");
  const [sidebarOpen, setSidebarOpen] = useState(false);


  useEffect(() => {

    const username = Cookies.get("username");

    if (username) {
      setName(username);
    }

  }, []);


  return (

    <div className="user-dashboard">

      {/* SIDEBAR */}

      <UserSidebar
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
      />


      {/* MAIN */}

      <main className="dashboard-main">

        {/* HEADER */}

        <UserHeader
          name={name}
          setSidebarOpen={setSidebarOpen}
        />


        {/* YOUR EXISTING DASHBOARD CONTENT */}

        <div className="dashboard-content">


          {/* ================= WELCOME ================= */}

          <section className="welcome-section">

            <div>

              <span className="welcome-badge">
                <i className="bi bi-stars"></i>
                NEET PG 2026
              </span>

              <h1>
                Welcome back, {name}! 👋
              </h1>

              <p>
                Continue your preparation and become
                one step closer to your medical career.
              </p>

            </div>


            <div className="welcome-illustration">

              <i className="bi bi-mortarboard-fill"></i>

            </div>

          </section>


          {/* ================= STATISTICS ================= */}

          <section className="stats-grid">


            <div className="stat-card">

              <div className="stat-icon blue">
                <i className="bi bi-question-circle-fill"></i>
              </div>

              <div>

                <span>Total MCQs</span>

                <h3>1,250</h3>

                <small className="positive">
                  <i className="bi bi-arrow-up"></i>
                  12% this week
                </small>

              </div>

            </div>


            <div className="stat-card">

              <div className="stat-icon green">
                <i className="bi bi-check-circle-fill"></i>
              </div>

              <div>

                <span>Questions Solved</span>

                <h3>845</h3>

                <small className="positive">
                  <i className="bi bi-arrow-up"></i>
                  8% this week
                </small>

              </div>

            </div>


            <div className="stat-card">

              <div className="stat-icon purple">
                <i className="bi bi-clipboard-data-fill"></i>
              </div>

              <div>

                <span>Tests Attempted</span>

                <h3>28</h3>

                <small>
                  This month
                </small>

              </div>

            </div>


            <div className="stat-card">

              <div className="stat-icon orange">
                <i className="bi bi-trophy-fill"></i>
              </div>

              <div>

                <span>Average Score</span>

                <h3>78%</h3>

                <small className="positive">
                  <i className="bi bi-arrow-up"></i>
                  5% improved
                </small>

              </div>

            </div>

          </section>


          {/* ================= MCQ SECTION ================= */}

          <section className="section-block">

            <div className="section-heading">

              <div>
                <h2>Practice MCQs</h2>
                <p>
                  Strengthen your concepts with targeted practice.
                </p>
              </div>

              <Link to="/free-mcq">
                View All
                <i className="bi bi-arrow-right ms-2"></i>
              </Link>

            </div>


            <div className="mcq-grid">


              {/* FREE MCQ */}

              <div className="mcq-card free-card">

                <div className="mcq-card-top">

                  <div className="mcq-icon">
                    <i className="bi bi-journal-text"></i>
                  </div>

                  <span className="free-badge">
                    FREE
                  </span>

                </div>


                <h3>
                  Free MCQ Practice
                </h3>

                <p>
                  Practice important medical questions
                  and improve your preparation.
                </p>


                <div className="mcq-details">

                  <span>
                    <i className="bi bi-question-circle"></i>
                    500+ Questions
                  </span>

                  <span>
                    <i className="bi bi-clock"></i>
                    Practice Anytime
                  </span>

                </div>


                <Link
                  to="/free-mcq"
                  className="mcq-btn free-btn"
                >
                  Start Practice
                  <i className="bi bi-arrow-right"></i>
                </Link>

              </div>


              {/* PREMIUM MCQ */}

              <div className="mcq-card premium-card">

                <div className="premium-glow"></div>

                <div className="mcq-card-top">

                  <div className="mcq-icon premium-icon-bg">
                    <i className="bi bi-gem"></i>
                  </div>

                  <span className="premium-badge">
                    PREMIUM
                  </span>

                </div>


                <h3>
                  Premium MCQ Library
                </h3>

                <p>
                  Access high-quality exam-oriented
                  questions prepared by experts.
                </p>


                <div className="mcq-details">

                  <span>
                    <i className="bi bi-stars"></i>
                    10,000+ Questions
                  </span>

                  <span>
                    <i className="bi bi-graph-up"></i>
                    Detailed Analysis
                  </span>

                </div>


                <Link
                  to="/premium-mcq"
                  className="mcq-btn premium-btn"
                >
                  Explore Premium
                  <i className="bi bi-arrow-right"></i>
                </Link>

              </div>

            </div>

          </section>


          {/* ================= LOWER GRID ================= */}

          <section className="dashboard-lower">


            {/* RECENT TESTS */}

            <div className="recent-tests">

              <div className="section-heading">

                <div>
                  <h2>Recent Tests</h2>
                  <p>Your latest performance</p>
                </div>

                <Link to="/results">
                  View All
                </Link>

              </div>


              <div className="test-list">


                <div className="test-item">

                  <div className="test-icon">
                    <i className="bi bi-file-earmark-medical"></i>
                  </div>

                  <div className="test-name">
                    <strong>
                      Anatomy Practice Test
                    </strong>

                    <small>
                      25 Questions • 20 min
                    </small>
                  </div>

                  <div className="test-score">
                    <strong>84%</strong>
                    <span>Excellent</span>
                  </div>

                </div>


                <div className="test-item">

                  <div className="test-icon">
                    <i className="bi bi-heart-pulse"></i>
                  </div>

                  <div className="test-name">
                    <strong>
                      Physiology Mock Test
                    </strong>

                    <small>
                      50 Questions • 40 min
                    </small>
                  </div>

                  <div className="test-score">
                    <strong>76%</strong>
                    <span>Good</span>
                  </div>

                </div>


                <div className="test-item">

                  <div className="test-icon">
                    <i className="bi bi-capsule"></i>
                  </div>

                  <div className="test-name">
                    <strong>
                      Pharmacology MCQ
                    </strong>

                    <small>
                      30 Questions • 25 min
                    </small>
                  </div>

                  <div className="test-score">
                    <strong>91%</strong>
                    <span>Excellent</span>
                  </div>

                </div>

              </div>

            </div>


            {/* QUICK ACTIONS */}

            <div className="quick-actions">

              <div className="section-heading">

                <div>
                  <h2>Quick Actions</h2>
                  <p>Continue your preparation</p>
                </div>

              </div>


              <Link
                to="/free-mcq"
                className="quick-action"
              >

                <div className="quick-icon blue">
                  <i className="bi bi-lightning-fill"></i>
                </div>

                <div>
                  <strong>Quick Practice</strong>
                  <span>Start 10 random MCQs</span>
                </div>

                <i className="bi bi-chevron-right"></i>

              </Link>


              <Link
                to="/premium-mcq"
                className="quick-action"
              >

                <div className="quick-icon purple">
                  <i className="bi bi-gem"></i>
                </div>

                <div>
                  <strong>Premium Practice</strong>
                  <span>Expert level MCQs</span>
                </div>

                <i className="bi bi-chevron-right"></i>

              </Link>


              <Link
                to="/results"
                className="quick-action"
              >

                <div className="quick-icon green">
                  <i className="bi bi-bar-chart-fill"></i>
                </div>

                <div>
                  <strong>View Performance</strong>
                  <span>Check your progress</span>
                </div>

                <i className="bi bi-chevron-right"></i>

              </Link>

            </div>

          </section>


          {/* ================= PREMIUM BANNER ================= */}

          <section className="premium-banner">

            <div className="premium-banner-content">

              <span>
                <i className="bi bi-stars"></i>
                HOMOEOADDA PREMIUM
              </span>

              <h2>
                Unlock your full preparation potential.
              </h2>

              <p>
                Get unlimited access to premium MCQs,
                mock tests, detailed solutions and performance analysis.
              </p>

              <button
                onClick={() => navigate("/subscription")}
              >
                Upgrade to Premium
                <i className="bi bi-arrow-right ms-2"></i>
              </button>

            </div>


            <div className="premium-banner-icon">

              <i className="bi bi-gem"></i>

            </div>

          </section>


        </div>

      </main>

    </div>

  );

}

export default UserDashboard;